import React, { memo } from 'react';
import classNames from 'classnames';
import {
  FluentIcon,
} from '@fluentui/react-icons';
import { TColorKey, useIconStyles, useIconColorStyles } from '../styles/styles';

export interface IIconProps {
  IconComponent: FluentIcon;
  color: TColorKey;
}

export const StatusSummaryCardIcon: React.FunctionComponent<IIconProps> = memo(({
  IconComponent,
  color,
}: IIconProps) => {
  const classes = useIconStyles();
  const colorClasses = useIconColorStyles();

  return (
    <div className={classNames('ba-status-summary-card-icon-container', classes.iconContainer, colorClasses[color])}>
      <div className={classNames('ba-status-summary-card-icon', classes.icon)}>
        <IconComponent />
      </div>
    </div>
  );
});
